export const BUCKET_URL= process.env.REACT_APP_BUCKET_URL;
export const ADS_URL = process.env.REACT_APP_ADS_URL;